import classnames from "classnames";
import * as React from "react";

import { Color, COLORS } from "./consts";
import PrimaryButton, { PrimaryButtonColorProps } from "./PrimaryButton";
import styles from "./PrimaryButtonWhite.module.scss";

type Props = PrimaryButtonColorProps & {
  color?: Color | string;
};

export default function PrimaryButtonWhite({
  className,
  color,
  ...props
}: Props) {
  return (
    <PrimaryButton
      {...props}
      // @ts-ignore
      loadingSpinnerColour={!props.disabled && "dark"}
      primaryButtonColorClassName={classnames(className, styles.white)}
      textClassName={classnames({
        [styles.colorPurple]: color === COLORS.PURPLE,
        [styles.colorGradient]: color === COLORS.GRADIENT
      })}
    />
  );
}
